globalThis.backoffice = globalThis.backoffice || {};

backoffice.Loader = (function()
{
  function Loader() {
    $html = $('#loader-wrapper');
    if($html.length >= 1)
    {
      this.$html = $html;
    }
  }

  Loader.prototype = {
    init: function() {
      this.events();
    },
    events: function() {
      var me = this;

      me.$html.find('.close').click(function() {
        me.finish();
      });

      $(document).on('confirm', function() {
        me.finish();
      });

      $(document).on('confirm:complete', function(e, answer) {
        if(me.isCalled && answer) {
          me.start();
        } else {
          me.finish();
        }
        me.isCalled = false;
      });

      $('body').on('click', 'a.display-loader, .btn.display-loader', function() {
        me.isCalled = true;
        me.start();
      });

      $('body').on('submit', 'form.display-loader', function() {
        me.isCalled = true;
        me.start();
      });
    },
    start: function() {
      this.$html.show();
    },
    loading: function() {
      this.start();
    },
    finish: function(callback) {
      this.$html.hide();
      if(typeof callback === 'function') callback();
    }
  }

  return Loader;
})();
